module.exports = __webpack_public_path__ + "img/logo_2x.c9dd637c.png";